/**
 * Where the shop lives, as far as the panel is concerned.
 *
 * Every "view on the storefront" link used to derive this by stripping `admin.`
 * from the panel's own URL. That worked for exactly one naming scheme. On
 * `goldenadmin.techygarry.com` there is no `admin.` to strip, and on
 * `localhost:5174` there never was — so the links pointed back at the admin app
 * and every one of them opened a 404 inside the panel.
 *
 * A second variable is duller and cannot be wrong. Guessing one host from
 * another is the kind of cleverness that works until somebody renames a domain.
 */
const BASE = (import.meta.env.VITE_STOREFRONT_URL ?? '').replace(/\/+$/, '');

export const storefrontUrl = (path = '') => {
  if (!BASE) return null;
  return `${BASE}/${String(path).replace(/^\/+/, '')}`;
};

export default storefrontUrl;
